import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ProjectLocationModel } from '../store/models/project-location.model';
import { HttpClient } from '@angular/common/http';
import { api } from '../consts/url';

@Injectable({ providedIn: 'root' })
export class ProjectLocationService {
  constructor(private readonly http: HttpClient) { }

  public getAll(projectId: string): Observable<ProjectLocationModel.LocationDocument[]> {
    return this.http.get<ProjectLocationModel.LocationDocument[]>(api.project.location.crud(projectId))
  }

  public create(
    projectId: string,
    payload: ProjectLocationModel.API.CreateLocationDto,
  ): Observable<ProjectLocationModel.LocationDocument> {
    return this.http.post<ProjectLocationModel.LocationDocument>(api.project.location.crud(projectId), payload);
  }

  public update(
    locationId: string,
    payload: ProjectLocationModel.API.CreateLocationDto,
  ): Observable<ProjectLocationModel.LocationDocument> {
    return this.http.put<ProjectLocationModel.LocationDocument>(api.project.location.crudById(locationId), payload);
  }

  public remove(
    locationId: string,
  ): Observable<ProjectLocationModel.LocationDocument> {
    return this.http.delete<ProjectLocationModel.LocationDocument>(api.project.location.crudById(locationId));
  }
}
